module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFR.f1f2acfd.eot";